module.exports = __webpack_public_path__ + "media/8.487ba16b.mp3";